import {Component, Inject} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import { DOCUMENT } from '@angular/common';
import * as qs from 'qs';
import merge from 'lodash-es/merge';

import {TranslateService} from "app/translate/translate.service";
import {AlertComponent} from "app/views/modal/alert.component";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HelperService} from "app/lib/helper.service";
import {RegDayStats} from "app/models/reg_day.model";
import {ChartParams} from "app/views/chart/chart.component";
import {BaseComponent} from "app/views/base.component";
import {EventsService} from "app/lib/EventsService";
import {ModalService} from "app/views/modal/base_modal.component";
import {FilterParams} from "../../models/filter_form.model";
import { UserService } from "../user.service";


@Component({
	selector: 'reg-day',
	templateUrl: './reg_day.component.html'
})
export class RegDayComponent extends BaseComponent {
	stats: RegDayStats[] = [];

	totalLoader: boolean = false;
	paginationLoader: boolean = false;
	statsLoader: boolean = false;

	chartData = new ChartParams();

	public total: any;
	public dontLoad: any = {};

	addFilterParams = {
		dateFilters: ['datePaid', 'dateCreated', 'dateSiteCreated', 'dateTo', 'datePublished'],
		isRegDay: true,
		userType: 'user',
		dateType: 'dateCreated'
	};

	lpTracker = false;
	lpTrackerData = {
		active: {
			loader : false,
			count  : null
		},
		fallen: {
			loader : false,
			count  : null
		}
	};
	
	subjectsLoaderMap = {};

	constructor(
		@Inject(DOCUMENT) private document,
		public eventsService: EventsService,
		public helper: HelperService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public modalService: ModalService,
		public filter: FilterFormService,
		public userService: UserService,
		
	) {
		super(eventsService, userService, activatedRoute, filter, translate);

		this.chartData.setOptions({
			showLabels: [
				'countReg', 'siteCount', 'usersWithSite', 'publishedSites', 'uncomplitedSites', 'published', 'publishedFirst'
			],
			names: {
				'countReg': this.translate.__A('users.reg_day.countReg'),
				'siteCount': this.translate.__A('users.reg_day.created sites'),
				'createdSites': this.translate.__A('users.reg_day.created sites by period'),
				'usersWithSite': this.translate.__A('users.reg_day.usersWithSite'),
				'publishedSites': this.translate.__A('users.reg_day.publishedSites'),
				'uncomplitedSites': this.translate.__A('users.reg_day.uncomplitedSites'),
				'published': this.translate.__A('users.reg_day.published'),
				'publishedAction': this.translate.__A('users.reg_day.publishedAction'),
				'publishedFirst': this.translate.__A('users.reg_day.publishedFirst')
			}
		});
	}

	async getData() {
		const host = document.location.hostname;
		
		if (host === 'constructor.lptracker.ru' || host === '8-stat-dev.ukit.com' || host === 'stat-dev.ukit.com') {
			this.lpTracker = true;
		}

		this.lpTrackerData.active.count = null;
		this.lpTrackerData.fallen.count = null;

		await this.getChart();
		await this.getTotal();
		await this.getPagination();
	}


	// Получить данные для графика
	async getChart(params?: FilterParams) {
		if (this.dontLoad.chart) {
			return true;
		}

		this.chartData.showLoader();
		
		const { charts } = await this.userService.reg_day.chart(
			this.filter.getCopyFilterParams(params)
		).toPromise();
		this.chartData.data = charts;
		
		this.chartData.hideLoader();
	}


	// Получить данные для тотала
	async getTotal() {
		if (this.dontLoad.total) {
			return true;
		}

		this.total = null;

		if (!this.filter.filterParams.isShowRegDayTotal) {
			return true;
		}

		this.totalLoader = true;
		this.total = await this.userService.reg_day.total(
			this.filter.filterParams
		).toPromise();
		this.totalLoader = false;
	}


	// Получить данные для пагинации
	async getPagination() {
		const me = this;

		if (this.dontLoad.pagination) {
			await this.getStats();
			return true;
		}

		if (this.filter.filterParams.period !== 'summary') {
			this.paginationLoader = true;

			const pagination = await this.userService.reg_day.pagination(
				this.filter.filterParams
			).toPromise();
			me.pagination.fill(pagination);

			if (pagination) {
				me.updateLinks(
					me.userService.reg_day.getRealFullRoute()
				);
			}

			this.paginationLoader = false;
		}

		await this.getStats();
	}


	// Получить данные для stats
	async getStats() {
		const me = this;

		me.statsLoader = true;
		const { stats } = await me.userService.reg_day.stats(
			this.filter.getCopyFilterParams({
				paginationDate: me.pagination.getDate()
			})
		).toPromise();
		me.stats = stats;
		
		me.stats.forEach(function (stat) {
			let dates = me.helper.getTimeAsIntervals({
				timestamp: stat.timestamp,
				period: me.filter.filterParams.period
			});

			if (dates.length == 2) {
				stat.currentPeriod = dates[0] + '-' + dates[1];
			} else {
				stat.currentPeriod = dates[0];
			}

			stat.day = new Date(stat.timestamp).getDay();

			if (stat.currentPeriod == '') {
				stat.currentPeriod = 'summary';
			}
		});

		me.statsLoader = false;

		me.dontLoad = {};
	}


	// Клик по пагинации
	async onPageChange() {
		this.filter.filterParams.page = this.pagination.page;

		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);

		let params = this.filter.getApplyFilters(this.filter.filterParams),
			url = this.router.url.split('?')[0];

		params = qs.stringify(params, {encode: false});
		this.router.navigateByUrl(`${url}?${params}`, {relativeTo: this.activatedRoute});

		this.dontLoad = {
			total: true,
			chart: true,
			pagination: true
		};
	}


	// Кнопка - Скачать пользователей с приложениями
	downloadButton() {
		window.location.href = this.userService.reg_day.downloadFileRoute(
			this.filter.filterParams
		);

		this.modalService.open(AlertComponent, {
			title: 'INFO',
			message: this.translate.__A('common.download file')
		});
	}


	async showSubjectList(stat) {
		if (stat.subject.length === 0) {
			this.subjectsLoaderMap[stat.currentPeriod] = true;
			stat.subject = await this.userService.reg_day.get(
				{ ...this.filter.filterParams, groupDate: stat.groupDate, },
				'subject'
			).toPromise();
			delete this.subjectsLoaderMap[stat.currentPeriod];
		}
	}


	async getLpTrackerData(stat, type: string) {
		try {
			this.lpTrackerData[type].loader = true;
			this.lpTrackerData[type].count = await this.userService.reg_day.get(
				this.filter.getCopyFilterParams(<FilterParams>{
					lpType: type,
					groupDate: stat.groupDate
				}),
				'lptracker'
			).toPromise();
		} catch(err) {
			// тут скорее всего будет ошибка http-запроса, она выводиться автоматически.
			// Поэтому err игнорим
		}
		
		this.lpTrackerData[type].loader = false;
	}
}
